/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Panel_Emoji_Board_TitleInputs */



/**
* | output |
* | --- |
* | "Emoji" |
*
* @param {Panel_Emoji_Board_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const panel_emoji_board_title = /** @type {((inputs?: Panel_Emoji_Board_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Panel_Emoji_Board_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Эмодзи")
	return /** @type {LocalizedString} */ ("Emoji")
});